class ErrorFormatter {
    constructor(error) {
        this.error = error
        
    }

    format() {
        const formattedError = {}
        if(this.error.message = "requested time window is too large") {
            formattedError.errorType = "dateFilterError"
            formattedError.message = this.error.message[0].toUpperCase() + this.error.message.slice(1) + "."
        } else {
            formattedError.errorType = "unknown"
            formattedError.message = this.error.message
        }
        return formattedError
    }
}

module.exports = ErrorFormatter